import { ReusableMenuBackground } from "../ReusableMenuBackground";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { CreditsCounterContainer } from "../CreditsCounterContainer";
import { AdvicesContainer } from "../AdvicesContainer";
import { AudioManager, SoundTrack } from "../../AudioManager";
import { GameManager } from "../../GameManager";

export class MatchResultState extends Phaser.State {

    public static currentInstance: MatchResultState;

    private nextMatchButton: Phaser.Button;
    private levelSelectionButton: Phaser.Button;
    private replayButton: Phaser.Button;
    private reusableMenuBackground: ReusableMenuBackground;
    private blackLayer: Phaser.Sprite;

    public create(): void {

        MatchResultState.currentInstance = this;

        this.stage.disableVisibilityChange = true;

        this.nextMatchButton = null;
        this.levelSelectionButton = null;
        this.replayButton = null;

        const resultSceneBackground: Phaser.Image = this.add.image(0, 0, "texture_atlas_1", "fondo_menus");
        resultSceneBackground.scale.setTo(1.25);

        const scaledItemsContainer = this.add.group();
        scaledItemsContainer.y = (1 - GameVars.scaleY) * GameConstants.GAME_HEIGHT * .5;
        scaledItemsContainer.scale.y = GameVars.scaleY;

        this.reusableMenuBackground = new ReusableMenuBackground(this.game, ReusableMenuBackground.RESULT_SCENE);
        scaledItemsContainer.add(this.reusableMenuBackground);

        const creditsCounterContainer = new CreditsCounterContainer(this.game);
        scaledItemsContainer.add(creditsCounterContainer);

        let reporterImage: Phaser.Image;
        let playerImage: Phaser.Image;

        const playerTeamRace = GameVars.getPlayerData().race;

        // botones y mensaje derrota victoria
        if (GameVars.matchResult === GameConstants.VICTORY) {

            // la imagen de victoria
            let victoryImage = new Phaser.Image(this.game, 140, 450, "texture_atlas_5", "victory");
            victoryImage.anchor.set(.5);
            scaledItemsContainer.add(victoryImage);

            let pulseTween = this.game.add.tween(victoryImage.scale);
            pulseTween.to({ x: 1.05, y: .8 }, 300, Phaser.Easing.Linear.None, false);
            pulseTween.delay(50);
            pulseTween.to({ x: .95, y: 1.05 }, 700, Phaser.Easing.Elastic.Out);
            pulseTween.loop();
            pulseTween.start();

            const doorImage = new Phaser.Image(this.game, 590, 870, "texture_atlas_5", "loading_puerta");
            doorImage.scale.set(1.2);
            doorImage.anchor.set(.5, 1);
            doorImage.scale.y = GameVars.scaleY;
            this.add.existing(doorImage);

            playerImage = new Phaser.Image(this.game, 450, 900, "texture_atlas_5", "jugador_ganador_" + playerTeamRace);
            playerImage.anchor.set(.5, 1);
            playerImage.scale.y = GameVars.scaleY;
            this.add.existing(playerImage);

            reporterImage = new Phaser.Image(this.game, 245, 900, "texture_atlas_5", "reporter_win");
            reporterImage.anchor.setTo(.5, 1);
            reporterImage.scale.y = GameVars.scaleY;
            this.add.existing(reporterImage);

            this.nextMatchButton = new Phaser.Button(this.game, 686, 843, "texture_atlas_5", this.onClickNextMatchButton, this);
            this.nextMatchButton.setFrames("boton_next_on", "boton_next_off", "boton_next_on");
            this.nextMatchButton.anchor.set(.5);
            this.nextMatchButton.scale.set(0);
            this.add.existing(this.nextMatchButton);

        } else {
            // la imagen de derrota
            const defeatImage = new Phaser.Image(this.game, 384, 600, "texture_atlas_5", "defeat");
            defeatImage.anchor.set(.5);
            scaledItemsContainer.add(defeatImage);

            this.levelSelectionButton = new Phaser.Button(this.game, 68, 846, "texture_atlas_5", this.onClickLevelSelection, this);
            this.levelSelectionButton.setFrames("exit_button_on", "exit_button_off", "exit_button_on");
            this.levelSelectionButton.scale.y = GameVars.scaleY;
            this.levelSelectionButton.anchor.set(.5);
            this.levelSelectionButton.scale.set(0);
            this.add.existing(this.levelSelectionButton);

            this.replayButton = new Phaser.Button(this.game, 686, 843, "texture_atlas_5", this.onClickReplayButton, this);
            this.replayButton.setFrames("boton_replay_on", "boton_replay_off", "boton_replay_on");
            this.replayButton.anchor.set(.5);
            this.replayButton.scale.set(0);
            this.add.existing(this.replayButton);

            reporterImage = new Phaser.Image(this.game, 275, 940, "texture_atlas_5", "reporter_lose");
            reporterImage.anchor.set(.5, 1);
            reporterImage.scale.y = GameVars.scaleY;
            this.add.existing(reporterImage);

            playerImage = new Phaser.Image(this.game, 495, 940, "texture_atlas_5", "jugador_pierde_" + playerTeamRace);
            playerImage.anchor.set(.5, 1);
            playerImage.scale.y = GameVars.scaleY;
            this.add.existing(playerImage);
        }

        if (GameVars.playerGoals === 0) {
            this.showMenuButtons();
        }

        const advicesContainer = new AdvicesContainer(this.game);
        this.add.existing(advicesContainer);

        this.blackLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData("black_square"));
        this.blackLayer.scale.set(12, 16);

        this.add.tween(this.blackLayer)
            .to({ alpha: 0 }, 700, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.blackLayer.destroy();
            }, this);

        AudioManager.getInstance().playMusic(SoundTrack.MENUS);
    }

    public shutdown(): void {

        MatchResultState.currentInstance = null;

        super.shutdown();
    }

    public onCoinAdded(): void {

        this.reusableMenuBackground.onCoinAdded();
    }

    public showMenuButtons(): void {

        if (this.nextMatchButton) {
            this.game.add.tween(this.nextMatchButton.scale)
                .to({ x: 1, y: GameVars.scaleY }, 500, Phaser.Easing.Elastic.InOut, true, 100)
                .onComplete.add(this.startNextMatchButtonAnimation, this);
        }

        if (this.levelSelectionButton) {
            this.game.add.tween(this.levelSelectionButton.scale)
                .to({ x: 1, y: GameVars.scaleY }, 500, Phaser.Easing.Elastic.InOut, true, 100);
        }

        if (this.replayButton) {
            this.game.add.tween(this.replayButton.scale)
                .to({ x: 1, y: GameVars.scaleY }, 500, Phaser.Easing.Elastic.InOut, true, 100)
                .onComplete.add(this.startReplayButtonAnimation, this);
        }
    }

    public goToScene(nextScene: string): void {

        this.blackLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData("black_square"));
        this.blackLayer.scale.setTo(12, 16);
        this.blackLayer.alpha = 0;

        this.add.tween(this.blackLayer).to({ alpha: 1 }, 700, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.game.state.start(nextScene, true, false);
            }, this);
    }

    private startNextMatchButtonAnimation(): void {

        const pulseTween = this.game.add.tween(this.nextMatchButton.scale);
        pulseTween.to({ x: 1.05, y: .95 * GameVars.scaleY }, 300, Phaser.Easing.Linear.None, false);
        pulseTween.delay(50);
        pulseTween.to({ x: .95, y: 1.05 * GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out);
        pulseTween.loop();
        pulseTween.start();
    }

    private startReplayButtonAnimation(): void {

        const pulseTween = this.game.add.tween(this.replayButton.scale);
        pulseTween.to({ x: 1.05, y: .95 * GameVars.scaleY }, 300, Phaser.Easing.Linear.None, false);
        pulseTween.delay(50);
        pulseTween.to({ x: .95, y: 1.05 * GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out);
        pulseTween.loop();
        pulseTween.start();
    }

    private onClickLevelSelection(): void {

        this.goToScene("TrophyState");
        
        AudioManager.getInstance().playEffect("play");
    }

    private async onClickNextMatchButton(): Promise<void> {

        await GameManager.showInterstitialAd();
        this.goToScene("TrophyState");
        
        AudioManager.getInstance().playEffect("play");
    }

    private async onClickReplayButton(): Promise<void> {
      
        await GameManager.showInterstitialAd();
        GameManager.onMatchReplayed();
        this.goToScene("FootballFieldState");
        
        AudioManager.getInstance().playEffect("play");
        AudioManager.getInstance().stopMusic(SoundTrack.MENUS); 
    }
}
